/**
 * @owner @Appboy/core-objects
 */
export const customObjectsTypeNameObjectIdUsers = "/data_objects/:type_name/:object_id/users" as const;
